import PropTypes from 'prop-types';
import Controls from './Controls';
import ContactList from '../../../ContactList';
import useSearch from '../../../../hooks/useSearch';
import './SideBar.css';

const SideBar = ({
  contacts = [],
  setCurrentContactId = () => {},
  selectedContactId = null,
  onMenuToggle = () => {},
  isLoading = false,
}) => {
  const {
    searchTerm,
    setSearchTerm,
    isSearching,
    setIsSearching,
    cancelSearch,
  } = useSearch();

  const filteredContacts = contacts.filter((contact) => contact.name.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="side-bar">
      <div className={`side-bar-header ${(isSearching) ? 'searching' : ''}`}>
        <Controls
          searchTerm={searchTerm}
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          setSearchTerm={setSearchTerm}
          cancelSearch={cancelSearch}
          onMenuToggle={onMenuToggle}
        />
        {
          !isSearching && <div className="side-bar-tabs"></div>
        }
      </div>
      <div className={`contact-list-container ${(isSearching) ? 'searching' : ''}`}>
        <ContactList
          contacts={filteredContacts}
          selectedContactId={selectedContactId}
          onSelectContact={setCurrentContactId}
          emptyText={isLoading ? 'Loading contacts...' : 'No contacts found'}
        />
      </div>
    </div>
  );
};

SideBar.propTypes = {
  contacts: PropTypes.array,
  setCurrentContactId: PropTypes.func,
  selectedContactId: PropTypes.string,
  onMenuToggle: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default SideBar;
